import { render, staticRenderFns } from "./groupFitnessDashboardRatings.vue?vue&type=template&id=d88c6e08&scoped=true"
import script from "./groupFitnessDashboardRatings.vue?vue&type=script&lang=js"
export * from "./groupFitnessDashboardRatings.vue?vue&type=script&lang=js"
import style0 from "./groupFitnessDashboardRatings.vue?vue&type=style&index=0&id=d88c6e08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88c6e08",
  null
  
)

export default component.exports